import { memo, useMemo } from "react";
import { MessageButtonCell } from "shared/app/MessagePopup/components/MessageButtonCell";
import { Lead, LeadType } from "views/leads-id/types";

interface MessageCellProps {
  lead: Lead;
}

/**
 * Row action that opens the floating message pop-up for the lead's contact
 * (CRM-1133), so staff can send a message without opening the record.
 *
 * Deliberately not disabled for a lead with no application: the pop-up itself
 * disables the Chat chip and explains why ("To use chat, the contact must have
 * at least one application"), while Email and SMS stay available.
 */
export const MessageCell = memo(function MessageCell({
  lead
}: MessageCellProps) {
  const target = useMemo(
    () => ({
      contactId: lead.contact?.id,
      leadId: lead.id,
      isRealtorLead: lead.lead_type === LeadType.Realtor,
      applicationId: lead.application_id || undefined,
      applicantId: lead.applicant_id || undefined,
      contactName: `${lead.first_name} ${lead.last_name}`.trim()
    }),
    [
      lead.contact?.id,
      lead.id,
      lead.lead_type,
      lead.application_id,
      lead.applicant_id,
      lead.first_name,
      lead.last_name
    ]
  );

  return <MessageButtonCell target={target} />;
});
